import React from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import API from '../../../create/api';
import * as helper from '../../../../helper/index';
import { useParams, useHistory } from 'react-router-dom';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CommentIcon from '@mui/icons-material/Comment';
import Comment from './comment';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import moment from 'moment-timezone';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

const Item = styled(Paper)(({ theme }: any) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function BookParcel(props: any) {
  // const store = useStore();
  const history = useHistory();

  const { parcel_id } = props;
  const [load, setLoad]: any = React.useState(false);
  const { id: id_param }: any = useParams();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const [id, setID]: any = React.useState(id_param ?? parcel_id);
  const [get_log, set_log]: any = React.useState([]);

  const [booking_date, set_booking_date]: any = React.useState(moment().tz('Asia/Dhaka').format('YYYY-MM-DD'));
  const [memoNo, setMemoNo]: any = React.useState(null);
  const [customerName, setCustomerName]: any = React.useState(null);
  const [phoneNumber, setPhoneNumber]: [string | null, any] = React.useState(null);
  const [address, setAddress]: any = React.useState(null);
  const [areaName, setAreaName]: any = React.useState(null);
  const [riderName, setRiderName]: any = React.useState(null);
  const [weight, setWeight]: any = React.useState(1);
  const [COD, setCOD]: any = React.useState(0);
  const [details, setDetails]: any = React.useState(null);
  const [get_parcel, set_parcel]: any = React.useState(null);
  const [get_loading, set_loading]: any = React.useState(false);

  function setParcelData(parcel: any) {
    const {
      id,
      parcel_logs,
      created_at,
      // area,
      area,
      memoNo,
      customerName,
      phoneNumber,
      // rider,
      rider,
      merchant_COD: COD,
      address,
      details,
      // status,
      // company,
      // deliveryCharge,
      weight,
      booking_date,
    } = parcel;

    set_booking_date(booking_date);
    setWeight(weight);
    // company?.id && setCompany({ label: company?.name, value: company?.id });
    // setStatus({ label: status, value: status });
    set_parcel(parcel);
    setDetails(details);
    setAddress(address);
    setAreaName(area?.name ?? null);
    setRiderName(rider?.name ?? null);
    setCOD(COD);
    // setDeliveryCharge(deliveryCharge);
    // rider?.id && setRider({ label: rider?.name, value: rider?.id });
    setPhoneNumber(phoneNumber);
    setCustomerName(customerName);
    setMemoNo(memoNo);
    // area?.id && setArea({ label: area.name, value: area.id });
    // log
    const created = {
      created_at,
      details: 'Created',
      type: 'created',
    };
    set_log([created, ...(parcel_logs ?? [])]);
    // log

    setID(id);
    setLoad(true);
  }

  React.useEffect(() => {
    if (id) {
      API.get(`${process.env.REACT_APP_API_SERVER}/parcels`, id)
        .then((parcel) => {
          setParcelData(parcel);
        })
        .catch((e) => {
          helper.axiosErrorHandling(e);
        });
    } else {
      setLoad(true);
    }
  }, [id]);

  function get_icon(type: string) {
    if (type === 'created') {
      return <AccessTimeIcon />;
    }

    if (type === 'comment') {
      return <CommentIcon />;
    }

    if (type === 'status') {
      return <DoubleArrowIcon />;
    }

    if (type === 'rider') {
      return <DirectionsBikeIcon />;
    }

    return <TimelineDot />;
  }

  function MobileNo(mobile_no: string | null): boolean {
    if (mobile_no === null) {
      return true;
    }
    if (typeof mobile_no === 'string') {
      mobile_no = mobile_no.trim();

      if (mobile_no.includes(',')) {
        return mobile_no
          .split(',')
          .every(
            (num, i) =>
              (num?.trim()?.length === 11 &&
                new RegExp('^01', 'g').test(num?.trim()) &&
                new RegExp(/^\d+$/, 'g').test(num?.trim())) ??
              num?.trim()?.length === 0,
          );
      } else if (
        mobile_no?.length === 0 ||
        (new RegExp('^01', 'g').test(mobile_no) && new RegExp(/^\d+$/, 'g').test(mobile_no) && mobile_no?.length === 11)
      ) {
        return true;
      }
    }
    return false;
  }
  const showItem = (item: any) => {
    if (typeof item === 'object') {
      if (item != null) {
        return Object.entries(item).map((singleItem) => {
          if (['created_at', 'updated_at', 'id'].includes(singleItem[0])) {
            return '';
          }
          return `${singleItem[1]}\n`;
        });
      }
    } else {
      return item;
    }
  };

  return (
    load && (
      <>
        <div className="hidden md:block">
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Booking Date</div>
                <div className="text-black">{moment(booking_date).format('DD-MMM-YYYY')}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Status</div>
                <div className="text-black">{get_parcel?.status}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Invoice</div>
                <div className="text-black">{memoNo}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Customer Name</div>
                <div className="text-black">{customerName}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Mobile</div>
                <div className="text-black">{phoneNumber}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Address</div>
                <div className="text-black">{address}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Area</div>
                <div className="text-black">{areaName}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Rider Name</div>
                <div className="text-black">{riderName}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Weight</div>
                <div className="text-black">{weight} Kg</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Merchant COD</div>
                <div className="text-black">{COD}</div>
              </Item>
            </Grid>
            <Grid item xs={12} md={3}>
              <Item>
                <div>Details by Merchant</div>
                <div className="text-black">{details}</div>
              </Item>
            </Grid>
          </Grid>
        </div>
        <div className="md:hidden bg-white p-2 border border-gray-200 mb-2 shadow-sm">
          <div className="flex flex-wrap ">
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Booking Date</div>
              <div className="text-black">{moment(booking_date).format('DD-MMM-YYYY')}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Status</div>
              <div className="text-black">{get_parcel?.status}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Invoice</div>
              <div className="text-black">{memoNo}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Customer Name</div>
              <div className="text-black">{customerName}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Mobile</div>
              <div className="text-black">{phoneNumber}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Address</div>
              <div className="text-black">{address}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Area</div>
              <div className="text-black">{areaName}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Rider Name</div>
              <div className="text-black">{riderName}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Weight</div>
              <div className="text-black">{weight} Kg</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Merchant COD</div>
              <div className="text-black">{COD}</div>
            </div>
            <div className="w-full flex justify-between pb-2 border-b ">
              <div>Details by Merchant</div>
              <div className="text-black">{details}</div>
            </div>
          </div>
        </div>
        <Grid item xs={12} md={12}>
          {id && (
            <Grid xs={12} md={7} className="mt-4">
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Item>
                    ID: <b>{id}</b>
                  </Item>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Item>
                    Updated Date:
                    {get_parcel?.updated_at && moment(get_parcel.updated_at).format('DD-MMM-YYYY hh:mm a')}
                  </Item>
                </Grid>
              </Grid>
            </Grid>
          )}
          {id && (
            <Grid xs={12} md={5} className="mt-4">
              <Grid item xs={12} md={12} className="mt-3 md:mt-0">
                <Timeline
                  position={isMobile ? 'right' : 'alternate'}
                  sx={
                    isMobile
                      ? {
                          m: 0,
                          p: 0,
                          mt: 0.5,
                          [`& .${timelineItemClasses.root}`]: {
                            minHeight: 'auto',
                            mb: 1,
                          },
                          [`& .${timelineItemClasses.root}:before`]: {
                            flex: 0,
                            padding: 0,
                          },
                          '& .MuiTimelineSeparator-root': {
                            mr: 0.75,
                          },
                          '& .MuiTimelineConnector-root': {
                            minHeight: 16,
                          },
                        }
                      : undefined
                  }
                >
                  {get_log.map(
                    (
                      log: { created_at: string; details: string; type: string; diff: object; id: any },
                      index: number,
                    ) => {
                      return (
                        <TimelineItem key={index}>
                          {!isMobile && (
                            <TimelineOppositeContent color="text.secondary">
                              {moment(log.created_at).format('DD-MMM-YYYY hh:mm a')}
                            </TimelineOppositeContent>
                          )}
                          <TimelineSeparator>
                            {get_icon(log.type)}
                            {index !== get_log.length - 1 && <TimelineConnector />}
                          </TimelineSeparator>
                          <TimelineContent
                            className="w-full overflow-hidden"
                            sx={isMobile ? { py: 0.75, px: 0.5 } : undefined}
                          >
                            {isMobile && (
                              <div className="mb-1 text-xs text-gray-500 leading-snug">
                                {moment(log.created_at).format('DD-MMM-YYYY hh:mm a')}
                              </div>
                            )}
                            {log.type === 'diff' ? (
                              <div className="w-full overflow-x-auto border border-gray-200 rounded-md shadow-sm mt-1">
                                <Table size="small" sx={{ minWidth: isMobile ? 280 : 420 }}>
                                  <TableHead className="bg-gray-50">
                                    <TableRow>
                                      <TableCell sx={{ py: 1, px: 1, fontSize: '0.75rem', fontWeight: 'bold' }}>Field</TableCell>
                                      <TableCell sx={{ py: 1, px: 1, fontSize: '0.75rem', fontWeight: 'bold' }}>Old</TableCell>
                                      <TableCell sx={{ py: 1, px: 1, fontSize: '0.75rem', fontWeight: 'bold' }}>New</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {Object.entries(log.diff).map((item: any) => {
                                      return (
                                        <TableRow key={item[0]} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                          <TableCell sx={{ py: 0.5, px: 1, fontSize: '0.75rem', wordBreak: 'break-word' }}>{item[0]}</TableCell>
                                          <TableCell sx={{ py: 0.5, px: 1, fontSize: '0.75rem', wordBreak: 'break-word', color: 'error.main' }}>{showItem(item[1]?.__old)}</TableCell>
                                          <TableCell sx={{ py: 0.5, px: 1, fontSize: '0.75rem', wordBreak: 'break-word', color: 'success.main' }}>{showItem(item[1]?.__new)}</TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </div>
                            ) : (
                              log.details ?? ''
                            )}
                          </TimelineContent>
                        </TimelineItem>
                      );
                    },
                  )}
                </Timeline>
              </Grid>

              <Grid item xs={12} md={12}>
                <Comment
                  parcel_id={id}
                  reload_parcel={async () => {
                    await API.get(`${process.env.REACT_APP_API_SERVER}/parcels`, id)
                      .then((parcel) => {
                        setParcelData(parcel);
                      })
                      .catch((e) => {
                        helper.axiosErrorHandling(e);
                      });
                  }}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </>
    )
  );
}
